import { render, staticRenderFns } from "./VehicleFaultRecord.vue?vue&type=template&id=5a797e44&scoped=true&"
import script from "./VehicleFaultRecord.vue?vue&type=script&lang=js&"
export * from "./VehicleFaultRecord.vue?vue&type=script&lang=js&"
import style0 from "./VehicleFaultRecord.vue?vue&type=style&index=0&id=5a797e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a797e44",
  null
  
)

export default component.exports